module.exports = __webpack_public_path__ + "images/54460748a5ab85c82b2cad4945da0df5.jpg";